import { render, staticRenderFns } from "./CreateNumberV4.vue?vue&type=template&id=596750c7&scoped=true"
import script from "./CreateNumberV4.vue?vue&type=script&lang=js"
export * from "./CreateNumberV4.vue?vue&type=script&lang=js"
import style0 from "./CreateNumberV4.vue?vue&type=style&index=0&id=596750c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596750c7",
  null
  
)

export default component.exports